export default "/assets/trash-can.svg";